import React, { useEffect, useState } from 'react';
import EditableUnitChip from './EditableUnitChip';
import {
  PREVIEW_EXPANSION,
  applyVillaLabelOverride,
  generateVillaPreviews,
  isMorePreviewLabel,
  nextPreviewExpansion,
  validateVillaLabelChange,
} from './communitySiteUtils';

const VillaPreviewTable = ({ street, onStreetChanged }) => {
  const [expansion, setExpansion] = useState(PREVIEW_EXPANSION.COLLAPSED);

  useEffect(() => {
    setExpansion(PREVIEW_EXPANSION.COLLAPSED);
  }, [street.flatsPerFloor]);

  const villas = generateVillaPreviews(street, { expansion });
  if (villas.length === 0) return null;

  const editable = Boolean(onStreetChanged);

  return (
    <div className="community-flat-preview">
      <div className="community-flat-preview-header">
        <span aria-hidden>🏡</span>
        <span>{street.name} — Auto Generate Preview</span>
      </div>
      {editable && (
        <p className="community-flat-preview-hint">
          Tap a villa number to edit. Duplicates are not allowed.
        </p>
      )}
      <div className="community-flat-preview-body community-flat-preview-villas">
        {villas.map((label, index) => {
          const villaIndex = index + 1;
          if (isMorePreviewLabel(label)) {
            return (
              <button
                key="more-villas"
                type="button"
                className="community-flat-preview-more inline"
                onClick={() => setExpansion(nextPreviewExpansion(expansion))}
              >
                {label}
              </button>
            );
          }

          return (
            <EditableUnitChip
              key={villaIndex}
              label={label}
              editable={editable}
              validate={value => validateVillaLabelChange(street, villaIndex, value)}
              onSubmitted={value =>
                onStreetChanged?.(applyVillaLabelOverride(street, villaIndex, value))
              }
            />
          );
        })}
      </div>
    </div>
  );
};

export default VillaPreviewTable;
